<template>
  <div class="newdirect-wrap">
    <ul class="modal-form">
      <el-form :model="formData" :rules="rules" ref="directFormRef">
        <li class="form-item">
          <span class="form-label">地域：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.district" @change="(val) => val === '' && clearAutoExtendTargets('REGION')">
              <el-radio label="">不限</el-radio>
              <el-radio label="CITY">按省市</el-radio>
            </el-radio-group>
            <div class="region-select-wrap" v-show="formData.district === 'CITY'">
              <el-select v-model="formData.location_type">
                <el-option label="居住在该地区的用户" value="HOME"> </el-option>
                <el-option label="到该地区旅行的用户" value="TRAVEL"> </el-option>
                <el-option label="该地区内的所有用户" value="ALL"> </el-option>
                <el-option label="正在该地区的用户" value="CURRENT"> </el-option>
              </el-select>
              <div class="region-content">
                <el-cascader
                  class="cascader-wrap"
                  v-model="formData.city"
                  :options="regionOptions"
                  collapse-tags
                  ref="areaCascader"
                  :props="{
                    multiple: true,
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                  }"
                  clearable
                ></el-cascader>
                <el-button class="select-all-btn" type="text" @click="selectAllRegion">全选</el-button>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">性别：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.gender" @change="(val) => val === 'GENDER_UNLIMITED' && clearAutoExtendTargets('GENDER')">
              <el-radio label="GENDER_UNLIMITED">不限</el-radio>
              <el-radio label="GENDER_MALE">男</el-radio>
              <el-radio label="GENDER_FEMALE">女</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">年龄：</span>
          <div class="form-value">
            <div style="display: flex">
              <div style="margin-right: 20px" @click="noSelect('age')">
                <el-checkbox v-model="unage">不限</el-checkbox>
              </div>
              <el-checkbox-group v-model="formData.age" @change="changeAge">
                <el-checkbox v-for="item in age_type_list" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox v-model="formData.moreAgeMode" style="margin-left: 12px" @change="showMoreAge">更多分段</el-checkbox>
            </div>
            <el-transfer
              style="margin-top: 8px"
              v-if="formData.moreAgeMode"
              v-model="formData.moreAge"
              :props="{
                key: 'value',
                label: 'label',
              }"
              :titles="['年龄段', '已选']"
              :data="more_age_type_list"
            ></el-transfer>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">网络：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('ac')">
              <el-checkbox v-model="unac">不限</el-checkbox>
            </div>
            <el-checkbox-group v-model="formData.ac">
              <el-checkbox label="WIFI">WiFi</el-checkbox>
              <el-checkbox label="2G">2G</el-checkbox>
              <el-checkbox label="3G">3G</el-checkbox>
              <el-checkbox label="4G">4G</el-checkbox>
              <el-checkbox label="5G" :disabled="!disableCustomPkg">5G</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">平台：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.platform" disabled>
              <el-radio label="IOS">iOS</el-radio>
              <el-radio label="ANDROID">Android</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item" v-show="formData.platform === 'ANDROID'">
          <span class="form-label" style="padding-top: 6px">安卓版本：</span>
          <div class="form-value">
            <el-select v-model="formData.android_osv">
              <el-option v-for="item of android_osv_list" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </li>
        <li class="form-item" v-show="formData.platform === 'IOS'">
          <span class="form-label" style="padding-top: 6px">IOS版本：</span>
          <div class="form-value">
            <el-select v-model="formData.ios_osv">
              <el-option v-for="item of ios_osv_list" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">行为兴趣：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.interest_action_mode" @change="changeInterestAction">
              <el-radio label="UNLIMITED">不限</el-radio>
              <el-radio label="RECOMMEND">系统推荐</el-radio>
              <el-radio label="CUSTOM">自定义</el-radio>
            </el-radio-group>
            <div class="interest-wrap" v-show="formData.interest_action_mode === 'CUSTOM'">
              <el-form-item prop="behavior_interest">
                <div class="wrap-header">
                  <span class="header-text">行为在</span>
                  <el-select v-model="formData.action_scene" style="width: 220px" multiple collapse-tags @change="searchInterest()">
                    <el-option v-for="item in action_scene_type_list" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <span class="header-text">中，选择用户</span>
                  <el-select v-model="formData.action_days" style="width: 90px" @change="searchInterest()">
                    <el-option label="7天" value="7"> </el-option>
                    <el-option label="15天" value="15"> </el-option>
                    <el-option label="30天" value="30"> </el-option>
                    <el-option label="60天" value="60"> </el-option>
                    <el-option label="90天" value="90"> </el-option>
                    <el-option label="180天" value="180"> </el-option>
                    <el-option label="365天" value="365"> </el-option>
                  </el-select>
                  <span class="header-text">内发生行为：</span>
                </div>
              </el-form-item>
              <div class="transfer-wrap">
                <span class="transfer-title">行为：</span>
                <interest-transfer :options="transferList.behaviorList" ref="actionRef" @selectChange="selectChange"></interest-transfer>
                <span class="transfer-title">兴趣：</span>
                <interest-transfer :options="transferList.interestList" ref="interestRef" @selectChange="selectChange"></interest-transfer>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item" v-show="disableCustomPkg">
          <span class="form-label">抖音达人：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.aweme_fan" @change="changeAweneFanType">
              <el-radio label="NONE">不限</el-radio>
              <el-radio label="CUSTOM">自定义</el-radio>
            </el-radio-group>
            <div class="interest-wrap" v-show="formData.aweme_fan === 'CUSTOM'">
              <el-form-item>
                <div class="wrap-header">
                  <span class="header-text">定向与以下达人产生</span>
                  <el-cascader
                    style="width: 220px"
                    v-model="formData.aweme_fan_behaviors"
                    :options="dyList"
                    :props="{ multiple: true, emitPath: false }"
                    @change="changeDyBehavior"
                    collapse-tags
                  ></el-cascader>
                  <span class="header-text">互动的用户</span>
                </div>
              </el-form-item>
              <div class="transfer-wrap">
                <dy-transfer
                  ref="dyTransferRef"
                  @selectChange="selectChange"
                  :dySelectBehaviorList="formData.aweme_fan_behaviors"
                  :classifyList="dyClassifyTree"
                ></dy-transfer>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">穿山甲媒体定向：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.superior_popularity_type">
              <el-radio label="NONE">不限</el-radio>
              <el-radio label="GAME" :disabled="disableCustomPkg">游戏优质媒体</el-radio>
              <el-radio label="CUSTOM">自定义媒体包</el-radio>
            </el-radio-group>
            <div class="custom-wrap" v-show="formData.superior_popularity_type === 'CUSTOM'">
              <list-check @selectChange="selectChange" ref="customFlowRef" :dataList="customFlowPkg"></list-check>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">设备类型：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('device_type')">
              <el-checkbox v-model="undevice_type">不限</el-checkbox>
            </div>
            <el-checkbox-group v-model="formData.device_type">
              <el-checkbox v-for="item in device_type_list" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">已安装用户：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.hide_if_exists">
              <el-radio label="0">不限</el-radio>
              <el-radio label="1" :disabled="formData.platform === 'IOS'">过滤</el-radio>
              <el-radio
                label="2"
                :disabled="
                  !disableCustomPkg ||
                  (delivery_placement && delivery_placement.delivery_range === 'UNIVERSAL') ||
                  formData.platform === 'IOS'
                "
                >定向</el-radio
              >
            </el-radio-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">过滤已转化用户：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.hide_if_converted">
              <el-radio v-for="item in hide_if_converted_type_list" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item" v-show="formData.hide_if_converted === 'APP' && disableCustomPkg">
          <span class="form-label">过滤时间：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.filter_time">
              <el-radio v-for="item in filter_time_type_list" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">运营商：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('carrier')">
              <el-checkbox v-model="uncarrier">不限</el-checkbox>
            </div>
            <el-checkbox-group v-model="formData.carrier" :disabled="!disableCustomPkg">
              <el-checkbox v-for="item in carrier_type_list" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <li class="form-item" v-show="disableCustomPkg">
          <span class="form-label">新用户：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('activate_type')">
              <el-checkbox v-model="unactivate_type">不限</el-checkbox>
            </div>
            <el-checkbox-group
              v-model="formData.activate_type"
              :disabled="delivery_placement && delivery_placement.delivery_range === 'UNIVERSAL'"
            >
              <el-checkbox v-for="item in activate_type_list" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <li class="form-item" v-show="formData.platform === 'ANDROID'">
          <span class="form-label">手机品牌：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.device_brand">
              <el-radio label="">不限</el-radio>
              <el-radio label="1">按品牌</el-radio>
            </el-radio-group>
            <el-transfer
              v-show="formData.device_brand === '1'"
              class="brand-transfer"
              filterable
              filter-placeholder="请输入品牌查询"
              v-model="selectBrand"
              :data="brandList"
              @change="selectChange"
            ></el-transfer>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">手机价格：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.launch_price">
              <el-radio label="">不限</el-radio>
              <el-radio label="1">自定义</el-radio>
            </el-radio-group>
            <div class="price-wrap" v-show="formData.launch_price === '1'">
              <div class="fast-wrap">
                <span class="fast-label">快捷设置：</span>
                <span :class="['check-btn', curPrice === 1 ? 'cur' : '']" @click="setPrice(2000, 4000, 1)">2000元-4000元</span>
                <span :class="['check-btn', curPrice === 2 ? 'cur' : '']" @click="setPrice(4000, 6000, 2)">4000元-6000元</span>
                <span :class="['check-btn', curPrice === 3 ? 'cur' : '']" @click="setPrice(6000, 8000, 3)">6000元-8000元</span>
                <span :class="['check-btn', curPrice === 4 ? 'cur' : '']" @click="setPrice(8000, 11000, 4)">8000元以上</span>
              </div>
              <div class="slider-wrap">
                <div class="slider-content">
                  <el-slider :max="11000" v-model="sliderValue" range :marks="marks" :step="500" show-stops @change="changeSliderPrice">
                  </el-slider>
                </div>
                <span class="price-tip">{{ sliderValue[0] }}元 - {{ sliderValue[1] }}元</span>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item" v-show="disableCustomPkg">
          <span class="form-label">职业状态：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.careerType">
              <el-radio label="NONE">不限</el-radio>
              <el-radio label="CUSTOM" :disabled="!disableCustomPkg">自定义</el-radio>
            </el-radio-group>
            <el-transfer
              v-show="formData.careerType === 'CUSTOM'"
              class="brand-transfer"
              filterable
              filter-placeholder="输入查询"
              v-model="formData.career"
              :data="careerTypeList"
              @change="selectChange"
            ></el-transfer>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">智能扩量：</span>
          <div class="form-value" style="display: flex; align-item: center">
            <el-switch v-model="formData.auto_extend_enabled" :active-value="1" :inactive-value="0"> </el-switch>
            <span style="font-size: 14px; color: #606266; margin: 0 5px" v-show="formData.auto_extend_enabled">可放开定向</span>
            <el-checkbox-group v-model="formData.auto_extend_targets" v-show="formData.auto_extend_enabled">
              <el-checkbox label="AGE" :disabled="unage">年龄</el-checkbox>
              <el-checkbox label="REGION" :disabled="formData.district == ''">地域</el-checkbox>
              <el-checkbox label="GENDER" :disabled="formData.gender === 'GENDER_UNLIMITED'">性别</el-checkbox>
              <el-checkbox label="INTEREST_ACTION" :disabled="formData.interest_action_mode === 'UNLIMITED'">行为兴趣</el-checkbox>
              <el-checkbox label="CUSTOM_AUDIENCE" :disabled="disAudience">自定义人群</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label" style="padding-top: 6px">定向包名称：</span>
          <div class="form-value">
            <el-input
              type="text"
              placeholder="请填写"
              maxlength="10"
              show-word-limit
              style="width: 280px"
              v-model="formData.targeting_name"
            ></el-input>
          </div>
        </li>
      </el-form>
    </ul>
    <div class="button-wrap" style="text-align: right">
      <el-button type="primary" @click="saveDirectPkg" :loading="saveLoading">保存到定向包</el-button>
    </div>
  </div>
</template>

<script>
import { getPackParams, getInterestAction, newPack, flowPackage, awemeCategory } from "@/api/promotion.js";
import InterestTransfer from "./interestTransfer.vue";
import DyTransfer from "./dyTransfer.vue";
import ListCheck from "../common/listCheck.vue";
import optionList from "./optionData.js";
import {
  more_age_type_list,
  age_type_list,
  action_scene_type_list,
  device_type_list,
  hide_if_converted_type_list,
  filter_time_type_list,
  carrier_type_list,
  activate_type_list,
} from "./optionData";
import { mapState } from "vuex";
import { dyBehaviorList, careerTypeList } from "./dybehaviorList.js";
export default {
  components: {
    InterestTransfer,
    ListCheck,
    DyTransfer,
  },
  data() {
    return {
      more_age_type_list,
      age_type_list,
      action_scene_type_list,
      device_type_list,
      hide_if_converted_type_list,
      filter_time_type_list,
      carrier_type_list,
      activate_type_list,
      formData: {
        district: "",
        location_type: "HOME",
        city: [],
        gender: "GENDER_UNLIMITED",
        age: [],
        moreAgeMode: false,
        moreAge: [],
        ac: [],
        android_osv: "0.0",
        ios_osv: "0.0",
        interest_action_mode: "UNLIMITED",
        action_scene: ["E-COMMERCE", "NEWS", "APP", "SEARCH"],
        action_days: "7",
        aweme_fan: "NONE",
        superior_popularity_type: "NONE",
        platform: "IOS",
        device_type: [],
        hide_if_exists: "0",
        hide_if_converted: "APP",
        filter_time: "TODAY",
        carrier: [],
        activate_type: [],
        device_brand: "",
        launch_price: "",
        auto_extend_enabled: 0,
        auto_extend_targets: [],
        aweme_fan_behaviors: [], //抖音达人行为
        careerType: "NONE", //职业状态
        career: [],
        targeting_name: "",
      },
      selectBrand: [],
      sliderValue: [2000, 4000],
      curPrice: 1,
      marks: {
        0: "0元",
        2000: "2000元",
        5000: "5000元",
        11000: "+",
      },
      regionOptions: [],
      brandList: [],
      transferList: {
        behaviorList: [],
        interestList: [],
      },
      saveLoading: false,
      android_osv_list: optionList.android_osv_list,
      ios_osv_list: optionList.ios_osv_list,
      customFlowPkg: [], //自定义媒体包
      disableCustomPkg: true, //禁用游戏优质媒体和自定义媒体包（穿山甲时启用）
      disAudience: true, //是否禁用智能扩量的自定义人群
      rules: {
        behavior_interest: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (this.formData.action_scene.length === 0) {
                callback(new Error("部分数据填写不完整"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      dyList: dyBehaviorList,
      dyClassifyTree: [],
      timer: null,
      careerTypeList: careerTypeList,
    };
  },
  mounted() {
    this.getOptionList();
  },
  methods: {
    searchInterest(cb) {
      if (this.formData.action_scene.length > 0 && this.formData.action_days !== "") {
        getInterestAction({
          actionScene: this.formData.action_scene.join(),
          actionDays: this.formData.action_days,
        }).then((res) => {
          if (res.code === "0000") {
            this.transferList.behaviorList = res.action;
            this.transferList.interestList = res.interest;
            if (cb) {
              cb.call(this);
            }
          }
        });
      }
    },
    changeInterestAction(val) {
      if (val === "UNLIMITED") {
        //禁用智能扩量对应的内容
        this.clearAutoExtendTargets("INTEREST_ACTION");
      } else if (val === "CUSTOM" && this.transferList.behaviorList.length === 0) {
        console.log(1);
        this.searchInterest();
      }
    },
    setPrice(startPrice, endPrice, curIndex) {
      this.sliderValue = [startPrice, endPrice];
      this.curPrice = curIndex;
      this.selectChange();
    },
    changeSliderPrice() {
      this.curPrice = null;
      this.selectChange();
    },
    getOptionList() {
      getPackParams({
        platType: 1,
      }).then((res) => {
        this.regionOptions = res.region;
        this.brandList = Object.entries(res.device_brand).map((item) => ({
          key: item[0],
          label: item[1],
        }));
      });
    },
    selectAllRegion() {
      setTimeout(() => {
        let allData = [];
        const getId = (item) => {
          if (item.children) {
            item.children.forEach(getId);
          } else {
            allData.push(item.id);
          }
        };
        this.regionOptions.forEach(getId);
        this.formData.city = allData;
      });
    },
    changeAge() {
      if (this.formData.age.length > 0) {
        this.$set(this.formData, "moreAgeMode", false);
      }
    },
    showMoreAge() {
      if (this.formData.moreAgeMode) {
        this.formData.age = [];
        this.formData.moreAge = [];
        this.unage = false;
      }
    },
    //查询定自定义媒体包
    getDirectList(cb) {
      flowPackage({
        advertiserId: this.adCount.map((item) => item.advertiserId).join(),
      }).then((res) => {
        if (res.code === "0000") {
          this.customFlowPkg = res.flowPackages.map((item) => {
            item.id = item.flow_package_id;
            item.type = item.flow_package_type;
            return item;
          });
          if (cb) {
            cb.call(this);
          }
        }
      });
    },
    formatData() {
      let res = JSON.parse(JSON.stringify(this.formData));
      //地区
      if (res.district === "") {
        delete res.location_type;
        delete res.city;
      } else {
        // 子级全选则传父级, 子级未全选则传子级
        var arr = [];
        let CheckedNodes = this.$refs.areaCascader.getCheckedNodes();
        CheckedNodes = CheckedNodes.filter((option) => !(option.parent && option.parent.checked));
        for (let index = 0; index < CheckedNodes.length; index++) {
          arr.push(CheckedNodes[index].value);
        }
        res.simpleCity = arr;
      }
      //平台类型
      if (res.platform === "IOS") {
        delete res.android_osv;
      } else {
        delete res.ios_osv;
      }
      //手机品牌
      if (res.device_brand !== "") {
        res.device_brand = this.selectBrand.length > 0 ? this.selectBrand : [];
      } else {
        delete res.device_brand;
      }

      //手机价格
      if (res.launch_price !== "") {
        res.launch_price = this.sliderValue;
      } else {
        delete res.launch_price;
      }

      //行为兴趣
      if (res.interest_action_mode === "CUSTOM") {
        res.action_words = this.$refs.actionRef.getSelectList();
        res.interest_words = this.$refs.interestRef.getSelectList();
      }

      // 年龄
      if (res.moreAgeMode) {
        res.age = res.moreAge;
      }

      //媒体定向
      if (res.superior_popularity_type === "CUSTOM") {
        let exData = this.$refs.customFlowRef.selectItem;
        res.flow_package = exData.includeList.map((item) => item.id);
        res.exclude_flow_package = exData.excludeList.map((item) => item.id);
      }

      //抖音达人
      if (res.aweme_fan === "CUSTOM") {
        let data = this.$refs.dyTransferRef.getSelectList();
        //抖音达人回显需要的数据
        res.dyRebackData = {
          dyClassList: data.classList,
          dyUserList: data.userList,
        };
        console.log();
        res.aweme_fan_categories = data.classList.map((i) => i.id);
        res.aweme_fan_accounts = data.userList.map((i) => i.label_id);
      }

      //职业状态
      if (res.careerType !== "CUSTOM") {
        res.career = [];
      }
      for (let [key] of Object.entries(res)) {
        if (res[key] === "") {
          delete res[key];
        }
      }
      return res;
    },
    saveDirectPkg() {
      if (this.formData.targeting_name === "") {
        this.$alert("定向包名称必填", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let parmas = this.formatData();
      this.saveLoading = true;
      newPack({
        data: JSON.stringify(parmas),
        advertiserId: this.adCount[0].advertiserId,
      }).then((res) => {
        this.saveLoading = false;
        if (res.code === "0000") {
          this.$emit("closeDrawer");
          this.$message({
            message: "定向包新建成功",
            type: "success",
          });
        }
      });
    },
    checkData() {
      this.$refs.directFormRef.validate(() => {});
    },
    fillData(dataItem) {
      //地区
      if (dataItem.district) {
        this.formData.district = "CITY";
        this.formData.location_type = dataItem.location_type;
        this.formData.city = dataItem.city;
      } else {
        this.formData.district = "";
        this.formData.location_type = "HOME";
        this.formData.city = [];
      }
      this.formData.gender = dataItem.gender ? dataItem.gender : "GENDER_UNLIMITED";
      this.formData.moreAgeMode = dataItem.moreAgeMode;
      this.formData.age = dataItem.moreAgeMode ? [] : dataItem.age ? dataItem.age : [];
      this.formData.moreAge = dataItem.moreAgeMode ? dataItem.age : [];
      this.formData.ac = dataItem.ac ? dataItem.ac : [];
      this.formData.android_osv = dataItem.android_osv ? dataItem.android_osv : "0.0";
      this.formData.action_scene = dataItem.action_scene ? dataItem.action_scene : [];
      this.formData.action_days = dataItem.action_days ? dataItem.action_days : "";
      //行为兴趣
      this.formData.interest_action_mode = dataItem.interest_action_mode;
      if (dataItem.interest_action_mode === "CUSTOM") {
        this.searchInterest(() => {
          this.$refs.actionRef.setSelectList(dataItem.action_words);
          this.$refs.interestRef.setSelectList(dataItem.interest_words);
        });
      } else {
        this.$refs.actionRef.setSelectList([]);
        this.$refs.interestRef.setSelectList([]);
      }
      this.formData.superior_popularity_type = dataItem.superior_popularity_type ? dataItem.superior_popularity_type : "NONE";
      this.formData.platform = dataItem.platform ? dataItem.platform : "IOS";
      this.formData.device_type = dataItem.device_type ? dataItem.device_type : [];
      this.formData.hide_if_exists = dataItem.hide_if_exists ? dataItem.hide_if_exists : "0";
      this.formData.hide_if_converted = dataItem.hide_if_converted ? dataItem.hide_if_converted : "APP";
      this.formData.filter_time = dataItem.filter_time ? dataItem.filter_time : "TODAY";
      this.formData.carrier = dataItem.carrier ? dataItem.carrier : [];
      this.formData.activate_type = dataItem.activate_type ? dataItem.activate_type : [];
      //自定义媒体包
      if (this.formData.superior_popularity_type === "CUSTOM") {
        if (this.customFlowPkg.length > 0) {
          this.$refs.customFlowRef.selectItem.includeList = dataItem.flow_package.map((id) => {
            return this.customFlowPkg.find((item) => item.id === id);
          });
          this.$refs.customFlowRef.selectItem.excludeList = dataItem.exclude_flow_package.map((id) => {
            return this.customFlowPkg.find((item) => item.id === id);
          });
        } else {
          this.getDirectList(() => {
            this.$refs.customFlowRef.selectItem.includeList = dataItem.flow_package.map((id) => {
              return this.customFlowPkg.find((item) => item.id === id);
            });
            this.$refs.customFlowRef.selectItem.excludeList = dataItem.exclude_flow_package.map((id) => {
              return this.customFlowPkg.find((item) => item.id === id);
            });
          });
        }
      }
      //手机品牌
      if (dataItem.device_brand) {
        this.formData.device_brand = "1";
        this.selectBrand = dataItem.device_brand;
      } else {
        this.formData.device_brand = "";
        this.selectBrand = [];
      }
      //手机价格
      if (dataItem.launch_price) {
        this.formData.launch_price = "1";
        this.sliderValue = dataItem.launch_price;
      } else {
        this.formData.launch_price = "";
        this.sliderValue = [2000, 4000];
      }
      //智能定向
      this.formData.auto_extend_enabled = dataItem.auto_extend_enabled;
      this.formData.auto_extend_targets = dataItem.auto_extend_targets || [];

      this.formData.targeting_name = dataItem.targeting_name ? dataItem.targeting_name : "";

      //抖音达人
      this.formData.aweme_fan = dataItem.aweme_fan;
      this.$nextTick(() => {
        if (dataItem.aweme_fan === "CUSTOM") {
          this.formData.aweme_fan_behaviors = dataItem.aweme_fan_behaviors;
          this.$refs.dyTransferRef.setSelectList(dataItem.dyRebackData);
          this.changeDyBehavior(this.formData.aweme_fan_behaviors);
        } else {
          this.formData.aweme_fan_behaviors = [];
          this.$refs.dyTransferRef && this.$refs.dyTransferRef.clearData();
        }
      });
      //职业状态
      this.formData.careerType = dataItem.careerType;
      if (dataItem.careerType === "CUSTOM") {
        this.formData.career = dataItem.career;
      } else {
        this.formData.career = [];
      }
    },
    noSelect(field) {
      this.formData[field] = [];
      if (field === "age") {
        this.$set(this.formData, "moreAgeMode", false);
        this.clearAutoExtendTargets("AGE");
      }
    },
    clearCustomMediaList() {
      if (this.$refs.customFlowRef) {
        this.$refs.customFlowRef.clearAllList();
      }
    },
    clearAutoExtendTargets(key) {
      let keyList = this.formData.auto_extend_targets;
      let delIndex = keyList.findIndex((item) => item === key);
      if (delIndex > -1) {
        keyList.splice(delIndex, 1);
      }
    },
    //抖音达人相关
    changeAweneFanType(type) {
      if (type === "CUSTOM" && this.formData.aweme_fan_behaviors.length === 0) {
        this.$nextTick(() => {
          this.formData.aweme_fan_behaviors = ["FOLLOWED_USER"];
          this.changeDyBehavior(this.formData.aweme_fan_behaviors);
        });
      }
    },
    changeDyBehavior(val) {
      if (val.length > 0 && this.adCount.length > 0) {
        clearTimeout(this.timer);
        setTimeout(() => {
          awemeCategory({
            advertiserId: this.adCount[0].advertiserId,
            behaviors: val.join(),
          }).then((res) => {
            if (res.code === "0000") {
              this.dyClassifyTree = res.awemeCategories;
            }
          });
        }, 500);
      }
    },
    selectChange() {
      this.$store.commit("set_current_selected_targeting", this.formatData(this.formData));
    },
  },
  computed: {
    ...mapState({
      checkedApp: (state) => state.Promotion.checkedApp,
      adCount: (state) => state.Promotion.adCount,
      delivery_placement: (state) => state.Promotion.draft_adset.delivery_placement,
      audience: (state) => state.Promotion.draft_adset.audience,
    }),
    unage: {
      get() {
        return this.formData.age.length > 0 || this.formData.moreAgeMode ? false : true;
      },
      set() {},
    },
    unac: {
      get() {
        return this.formData.ac.length === 0 ? true : false;
      },
      set() {},
    },
    uncarrier: {
      get() {
        return this.formData.carrier.length === 0 ? true : false;
      },
      set() {},
    },
    unactivate_type: {
      get() {
        return this.formData.activate_type.length === 0 ? true : false;
      },
      set() {},
    },
    undevice_type: {
      get() {
        return this.formData.device_type.length === 0 ? true : false;
      },
      set() {},
    },
  },
  watch: {
    audience(value) {
      if (!value) {
        this.disAudience = true;
      } else {
        let flag = true;
        value.forEach((item) => {
          if (item.retargeting_tags_exclude.length + item.retargeting_tags_include.length > 0) {
            flag = false;
          }
        });
        this.disAudience = flag;
      }
      if (this.disAudience) {
        this.clearAutoExtendTargets("CUSTOM_AUDIENCE");
      }
    },
    checkedApp(value) {
      if (value.os_type === "ANDROID") {
        this.formData.platform = "ANDROID";
      } else if (value.os_type === "IOS") {
        this.formData.platform = "IOS";
        //ios下已安装用户只能选择不限
        this.formData.hide_if_exists = "0";
      }
    },
    adCount(value) {
      if (value.length > 0) {
        this.getDirectList();
      }
    },
    delivery_placement(value) {
      if (value.delivery_range === "UNION") {
        this.disableCustomPkg = false;
        //投放位置位穿山甲时放开游戏优质媒体和自定义媒体包
        //隐藏用户属性
        //已安装用户只能选不限
        this.formData.hide_if_exists = "0";
        //职业只能选择不限
        this.formData.careerType = "NONE";
        //运营商只能选择不限
        this.formData.carrier = [];
        //网络不可选择5G
        if (this.formData.ac.includes("5G")) {
          let delIndex = this.formData.ac.findIndex((item) => item === "5G");
          this.formData.ac.splice(delIndex, 1);
        }
        //抖音达人属性隐藏
        this.formData.aweme_fan = "NONE";
      } else {
        this.formData.superior_popularity_type = "NONE";
        this.disableCustomPkg = true;
      }

      //通投智选 已安装用户只能选择过滤，新用户只能选择不限
      if (value.delivery_range === "UNIVERSAL") {
        if (this.formData.hide_if_exists === "2") {
          this.formData.hide_if_exists = "0";
        }
        this.formData.activate_type = [];
      }
    },
    formData: {
      handler(val) {
        this.$store.commit("set_current_selected_targeting", this.formatData(val));
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.newdirect-wrap {
  box-sizing: border-box;
  padding-top: 10px;
  .modal-form {
    margin: 0px;
    padding: 0px;
    list-style: none;
    .form-item {
      display: flex;
      margin-bottom: 20px;
      .form-label {
        flex-shrink: 0;
        display: inline-block;
        width: 114px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        // padding-top: 6px;
      }
      .form-value {
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(0, 0, 0, 0.65);
        }
        .brand-transfer {
          margin-top: 10px;
          /deep/ .el-transfer-panel {
            width: 180px;
            height: 300px;
          }
        }
        .price-wrap {
          margin-top: 16px;
          .fast-wrap {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            .fast-label {
            }
            .check-btn {
              border-radius: 2px;
              border: 1px solid rgba(0, 0, 0, 0.15);
              box-sizing: border-box;
              background: rgba(255, 255, 255, 1);
              padding: 5px 8px;
              margin-right: 12px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
          }
          .slider-wrap {
            margin: 20px 0;
            width: 98%;
            display: flex;
            align-items: center;
            .slider-content {
              width: 100%;
              /deep/ .el-slider__marks-text {
                white-space: nowrap;
              }
              /deep/ .el-slider__button {
                width: 10px;
                height: 10px;
              }
              /deep/ .el-slider__runway {
                background: rgba(196, 227, 255, 1);
                border-radius: 0px;
              }
              /deep/ .el-slider__stop {
                border: 1px solid rgba(193, 224, 253, 1);
                box-sizing: border-box;
              }
            }

            .price-tip {
              display: inline-block;
              flex-shrink: 0;
              width: 120px;
              padding-left: 16px;
              box-sizing: border-box;
              white-space: nowrap;
              font-size: 13px;
              color: #333;
            }
          }
        }
        .region-select-wrap {
          padding-top: 10px;
          .region-content {
            margin-top: 10px;
            .cascader-wrap {
              width: 100%;
            }
            .select-all-btn {
              margin-left: 10px;
            }
          }
        }
        .interest-wrap {
          margin-top: 10px;
          .wrap-header {
            display: flex;
            align-items: center;
            .header-text {
              margin: 0 5px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
            }
          }
          .transfer-wrap {
            .transfer-title {
              display: block;
              padding: 10px 6px 6px 0;
              font-size: 12px;
              font-weight: bold;
            }
          }
        }
        .custom-wrap {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
